export const setting = {
  record_outgoing: {
    title: 'Запись исходящих звонков',
    warning_text: 'Записи разговоров недоступны для ',
    warning_link_text: ' вашего пакета ',
    warning_text_end: ' АТС'
  },
  on_record: 'Включить запись?',
  off_record: 'Выключить запись?'
};
